import $ from 'jquery'
import config from '../config/api'
import configApp, { isDevEnv } from '../config/app'
import _ from 'underscore'

export function appendFormData(data = {}, key, value) {
  if (data instanceof FormData) {
    data.append(key, value)
  } else if (_.isObject(data)) {
    data[key] = value
  } else {
    data += `&${encodeURIComponent(key)}=${encodeURIComponent(value)}`
  }
  return data
}

function request(method, url, data, options = {}) {

  let settings = {
    type: method,
    url: url,
    data: data,
    dataType: 'json',
    cache: false,
    xhrFields: {
      withCredentials: true,
    },
  }

  $.extend(settings, options)

  return $.ajax(settings)
}

function setApiBaseUrl(orgUrl) {
  if (!isDevEnv() || orgUrl == null) {
    return orgUrl
  }

  let domainPrefix = 'dashboard-'
  var env = window.location.host.split('.')[0].replace(domainPrefix, '')
  if (env.startsWith('localhost')) {
    return orgUrl
  }

  var urlObj = new URL(orgUrl)
  urlObj.host = urlObj.host.replace(
    /^(api)-([a-zA-Z1-9-]+)-(cmc|capabilities|employer|candidate).(.*)$/,
    `$1-${env}-$3.$4`
  )

  return urlObj.href
}

function joinUrl(baseUrl, url) {
  return url.indexOf('://') > -1 ? url : baseUrl + url
}

function service(name) {
  const baseUrl = setApiBaseUrl(config.urls[name])
  return {
    get(url, data, options = {}) {
      url = joinUrl(baseUrl, url)
      return request('GET', url, data, options)
    },
    post(url, data, options = {}) {
      url = joinUrl(baseUrl, url)
      return request('POST', url, data, options)
    },
    put(url, data, options = {}) {
      url = joinUrl(baseUrl, url)
      data = appendFormData(data, '_method', 'put')
      return request('POST', url, data, options)
    },
    patch(url, data, options = {}) {
      url = joinUrl(baseUrl, url)
      data = appendFormData(data, '_method', 'patch')
      return request('POST', url, data, options)
    },
    delete(url, data, options = {}) {
      url = joinUrl(baseUrl, url)
      data = appendFormData(data, '_method', 'delete')
      return request('POST', url, data, options)
    },
    url(url = '') {
      return joinUrl(baseUrl, url)
    },
  }
}

export default {
  service,
}
